import React from 'react'
// styles
import "./LessonItem.scss";
// assets
import icon__label_recommended from "../../assets/icons/icon-label--recommended.svg";
import icon__favorite from "../../assets/icons/icon-favorite--2.svg";
import icon__favorited from "../../assets/icons/icon-favorited.svg";
import icon__arrow_right from "../../assets/icons/logo-arrow--right.svg";
import { useFavoriteContext } from '../../context/providers/FavoriteContext';

const LessonBox = (props) => {
	const { removeFromFavorite, addToFavorite } = useFavoriteContext();
	const handleClick = (e) => {
		if (props.item.favoriteKey) {
			removeFromFavorite(props.item.favoriteKey);
		} else {
			addToFavorite(props.item._id);
		}
	};
    return (
			<article className="lessons__item lessons__item--box px-3 py-4 px-md-4 py-md-5">
				<div className="d-flex align-items-center">
					<div className="lessons__item-label d-flex align-items-center fw--600 color--primary">
						<div>
							<img src={icon__label_recommended} alt="Label icon" className="mr-2" />
						</div>
						Recommanded
					</div>
				</div>
				<p onClick={()=>window.location.href=`/lesson/${props.item._id}/${props.item.category}/`}className="lessons__item-title d-block mt-1" style={{cursor:'pointer'}}>
					{props.item.title}
				</p>
				<p className="lessons__item-desc mt-1 mt-md-3">{props.item.description}</p>
				<div className="lessons__item-buttons d-flex mt-3 mt-md-5">
					<button className={props.item.favoriteKey?`btn  btn--accent btn--bordered`:`btn  btn--accent `} onClick={handleClick}>
						<img src={props.item.favoriteKey ? icon__favorite : icon__favorited} alt="" />
					</button>
					<button
					onClick={() => window.location.href = `/lesson/${props.item._id}/${props.item.category}`}
						className="btn btn--bordered btn--primary lessons__item-link ml-3"
					>
						<span className="pr-2">Start lesson</span>
						<img src={icon__arrow_right} alt="Arrow icon" />
					</button>
				</div>
			</article>
		);
}

export default LessonBox
